import { NamespaceConsumer, NamespaceShape, withNamespace } from '@ux/namespace-component';
import React from 'react';
import PropTypes from 'prop-types';

class Version extends NamespaceConsumer {
  render() {
    return (<span className={ this.namespace('version') }>
      {this.props.value}
    </span>);
  }
}

Version.propTypes = {
  ...NamespaceShape,
  value: PropTypes.string
};

export default withNamespace(Version);
